import { render, staticRenderFns } from "./taskRecord.vue?vue&type=template&id=097b22cd&scoped=true&"
import script from "./taskRecord.vue?vue&type=script&setup=true&lang=js&"
export * from "./taskRecord.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./taskRecord.vue?vue&type=style&index=0&id=097b22cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b22cd",
  null
  
)

export default component.exports